import { Fragment } from 'react';

import EditIcon from '@usas/ui-web/components/icons/EditIcon';
import DeleteIcon from '@usas/ui-web/components/icons/DeleteIcon';
import PlusIcon from '@usas/ui-web/components/icons/PlusIcon';
import ActionIntraPageButton from '@usas/ui-web/components/buttons/ActionIntraPageButton';

import { formatDateTimeTwelveHourClock, formatSubmittedDateTimeTwelveHourClock } from '@usas/ui-web/utils/DateFunctions';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const SmallDetailTableRow = ({ teamEntryMeetInfo, teamEntry, onView, onEdit, onDeleteTeamEntryClicked, onAdd }) => { 
  return (
    <Fragment>
      <div className={global.SmallDetailTableRow}>
        <div className={global.SmallTableDetailRowHead}>
          {teamEntry?.isReadOnly === true ? <span /> : <span className='hidden-xs'>{teamEntry?.omeMeetName || <span>&nbsp;</span>}</span>}{teamEntry?.isReadOnly === false && <span>&nbsp;</span>}
          {teamEntry?.omeMeetOrgUnitEntryId > 0
            ? <span>
              {teamEntry?.isReadOnly === true &&
                <div style={{ maxWidth: '180px' }}><ActionIntraPageButton onClick={(e) => onView(e, teamEntry)}>View</ActionIntraPageButton></div>}
              {teamEntry?.teamEntryDeleteCurrentlyAllowed === true &&
                <Fragment>
                  {teamEntry?.isReadOnly === true && <span>&nbsp;</span>}
                  <button className={global.IconButton} type="button" onClick={(e) => onDeleteTeamEntryClicked(e, teamEntryMeetInfo, teamEntry)}><DeleteIcon /></button>
                </Fragment>}
              {(teamEntry?.teamEntryCurrentlyAllowed === true || teamEntry?.teamEntryChangesCurrentlyAllowed === true) &&
                <Fragment>
                  {teamEntry?.teamEntryDeleteCurrentlyAllowed === true ?
                    <button className={global.IconButtonMobileMargin} type="button" onClick={(e) => onEdit(e, teamEntry)}><EditIcon /></button> :
                    <Fragment>
                      {teamEntry?.isReadOnly === true && <span>&nbsp;</span>}
                      <button className={global.IconButton} type="button" onClick={(e) => onEdit(e, teamEntry)}><EditIcon /></button>
                    </Fragment>}
                </Fragment>}
            </span>
            :
            <Fragment>
              {teamEntry?.teamEntryCurrentlyAllowed === true &&
                <button className={global.IconButton} type="button" onClick={(e) => onAdd(e, teamEntry)}> <PlusIcon toolTipText='Enter OME Meet' /> </button>}
            </Fragment>}
        </div>
        <div className={global.SmallTableRowInfo}>
          <div className='row'>
            <div className={[global.SmallTableRowLabels, 'col-xs-6 visible-xs'].join(' ')}>OME Meet Name</div>
            <div className={[global.SmallTableRowData, 'col-xs-6 visible-xs'].join(' ')}>{teamEntry?.omeMeetName || <span>&nbsp;</span>}</div>
            <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3'].join(' ')}>Entry Start Date</div>
            <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3'].join(' ')}>{teamEntry?.meetEntryStartDate === null ? <span>&nbsp;</span> : formatDateTimeTwelveHourClock(teamEntry?.meetEntryStartDate)}</div>
            <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3'].join(' ')}>Entry End Date</div>
            <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3'].join(' ')}>{teamEntry?.meetEntryEndDate === null ? <span>&nbsp;</span> : formatDateTimeTwelveHourClock(teamEntry?.meetEntryEndDate)}</div>
            <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3'].join(' ')}>Time Zone</div>
            <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3'].join(' ')}>{teamEntry?.timeZone || <span>&nbsp;</span>}</div>
            <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3'].join(' ')}>Team Entry Status</div>
            <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3'].join(' ')}>{teamEntry?.teamEntryStatus || <span>&nbsp;</span>} {teamEntry?.orgUnitSubmissionDatetime ? '- ' + formatSubmittedDateTimeTwelveHourClock(teamEntry?.orgUnitSubmissionDatetime) + ' ' + teamEntry?.timeZone : ''}</div>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

const SmallDetailTable = ({ teamEntryMeetInfo, orgUnitOmeMeetEntry, onView, onEdit, onDeleteTeamEntryClicked, onAdd }) => {
  return (
    <div className={global.SmallDetailTable}>
      {Array.isArray(orgUnitOmeMeetEntry) && orgUnitOmeMeetEntry.length > 0 &&
        orgUnitOmeMeetEntry.map((teamEntry, i) =>
          <SmallDetailTableRow
            key={i}
            teamEntryMeetInfo={teamEntryMeetInfo}
            teamEntry={teamEntry}
            onView={onView}
            onEdit={onEdit}
            onDeleteTeamEntryClicked={onDeleteTeamEntryClicked}
            onAdd={onAdd}
          />)}
    </div>
  );
};


const MeetTeamEntrySmallGrid = ({ gridData, isLoading, onView, onEdit, onDeleteTeamEntryClicked, onAdd }) => (
  <div className={[global.SmallTable, 'hidden-md hidden-lg'].join(' ')}>
    {isLoading === true
      ? (
        <div className={global.SmallTableRow}>
          <div className={global.SmallTableRowHead}>
            &nbsp;
          </div>
          <div className={global.SmallTableRowInfo}>
            <div className={global.SmallTableRowLabels}>
              Loading...
            </div>
          </div>
        </div>
      ) : gridData.length > 0
        ? gridData.map((teamEntry, i) => {
          return (
            <div className={global.SmallTableRow} key={i}>
              <div className={global.SmallTableRowHead}><span className='hidden-xs'>{teamEntry.orgUnitName || <span>&nbsp;</span>} {teamEntry.orgUnitName === 'Unattached' ? (teamEntry.parentOrgUnitName ? '- ' + teamEntry.parentOrgUnitName : '') : ''} {teamEntry?.parentOrgUnitCode ? '(' + teamEntry?.parentOrgUnitCode + ')' : ''}</span>&nbsp;
              </div>
              <div className={global.SmallTableRowInfo}>
                <div className='row'>
                  <div className={[global.SmallTableRowLabels, 'col-xs-6 visible-xs'].join(' ')}>Team Name</div>
                  <div className={[global.SmallTableRowData, 'col-xs-6 visible-xs'].join(' ')}>{teamEntry.orgUnitName || <span>&nbsp;</span>} {teamEntry.orgUnitName === 'Unattached' ? (teamEntry.parentOrgUnitName ? '- ' + teamEntry.parentOrgUnitName : '') : ''} {teamEntry?.parentOrgUnitCode ? '(' + teamEntry?.parentOrgUnitCode + ')' : ''}</div>
                </div>
              </div>
              <SmallDetailTable teamEntryMeetInfo={teamEntry} orgUnitOmeMeetEntry={teamEntry?.orgUnitOmeMeetEntry} onView={onView} onEdit={onEdit} onDeleteTeamEntryClicked={onDeleteTeamEntryClicked} onAdd={onAdd} />
            </div>
          )
        }) : (
          <div className={global.SmallTableRow}>
            <div className={global.SmallTableRowHead}>
              &nbsp;
            </div>
            <div className={global.SmallTableRowInfo}>
              <div className={global.SmallTableRowLabels}>No Team Entries</div>
            </div>
          </div>
        )
    }
  </div >
);

export default MeetTeamEntrySmallGrid;